import axios from 'axios';

import {NODE_URL, getContentType} from './api.config';
import {deduplicateGetRequests} from './get-request-deduplicator';

const axiosInstance = axios.create({
  baseURL: NODE_URL,
  headers: getContentType(),
  withCredentials: true,
});

deduplicateGetRequests(axiosInstance);

export default axiosInstance;
